import React from "react"
import { Col, Container, Row } from "react-bootstrap"

export const SectionTitle = (props) => {
    return (
        <Container>
            <Row>
                <Col>
                    <h1 className="text-center text-uppercase text-bold" style={{ color: '#4b0082' }}>
                        {props.title}
                    </h1>
                    <hr />
                    <p>{props.children}</p>
                </Col>
            </Row>
        </Container>
    )
}